export enum ValueType {
  Empty = 0,
  Boolean = 1,
  Int = 2,
  Double = 3,
  DateTime = 4,
  String = 5,
  Guid = 6
}
